<template>
<div class="row mt-5 mx-auto">
  <div class="col-xl-10">
    <ApolloQuery
        :query="gql => gql`${permissions}`"
        :variables="{ page: 0, perPage: 30 }"
    >
      <template v-slot="{ result: { loading, error, data } }">
        <!-- Loading -->
        <div v-if="loading" class="loading apollo">Loading...</div>

        <!-- Error -->
        <div v-else-if="error" class="error apollo">An error occurred</div>

        <!-- Result -->
        <div v-else-if="data" class="result apollo">
          <user-permissions-table :rows="data.permissions.objects"/>
        </div>

        <!-- No result -->
        <div v-else class="no-result apollo">No result :(</div>
      </template>
    </ApolloQuery>
  </div>
</div>
</template>

<script>
import {ALL_PERMISSIONS} from "@/gql";
import UserPermissionsTable from "@/components/settings/user-permissions-table";
export default {
name: "permission-component",
  components: {UserPermissionsTable},
  data(){
    return{
      permissions: ALL_PERMISSIONS
    }
  },
}
</script>

<style scoped>

</style>
